module.exports = __webpack_public_path__ + "img/email.17b7232f.svg";